import i18n from '@/plugins/i18n';
export const forms = [
    {
        type: 'select',
        name: 'signal_group',
        title: i18n.t('account.exception.type'),
        rules: {required: true},
        options: {
            data: [],
            label: 'name',
            track: 'ID'
        },
        modal: ['signal_group_id'],
        data: ['signal_info',],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'radio',
        name: 'is_alarm',
        title: i18n.t('account.exception.alarm'),
        default:false,
        rules: {},
        options: {
            type: 'locale',
            data: [
                {text: i18n.t('general.yes'), value: true},
                {text: i18n.t('general.no'), value: false},
            ],
        },
        modal: ['is_alert'],
        data: ['is_alert'],
        additionalButton: false,
        checkBox: false
    }
 
]
export default forms;


// WEBPACK FOOTER //
// ./src/pages/Alarmsis/Account/forms/exceptions.js